"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercetoolsError = void 0;
var json_stringify_safe_1 = __importDefault(require("json-stringify-safe"));
/**
 * The error class thrown by any of the utility classes.
 */
var CommercetoolsError = /** @class */ (function (_super) {
    __extends(CommercetoolsError, _super);
    function CommercetoolsError(message, data, status) {
        var _this = _super.call(this, message) || this;
        /**
         * Convenience mechanism for identifying that the error that's
         * just been caught is a CommercetoolsError.
         */
        _this.isCommercetoolsError = true;
        _this.data = data;
        _this.status = status;
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, CommercetoolsError.prototype);
        return _this;
    }
    /**
     * Utility for converting an AxiosError in to a CommercetoolsError.
     */
    CommercetoolsError.fromAxiosError = function (e) {
        var _a, _b, _c, _d;
        return new CommercetoolsError(e.message, {
            code: e.code,
            request: {
                url: e.config.url,
                method: e.config.method,
                headers: e.config.headers
            },
            response: {
                status: (_a = e.response) === null || _a === void 0 ? void 0 : _a.status,
                data: (_b = e.response) === null || _b === void 0 ? void 0 : _b.data,
                headers: (_c = e.response) === null || _c === void 0 ? void 0 : _c.headers
            }
        }, (_d = e.response) === null || _d === void 0 ? void 0 : _d.status);
    };
    CommercetoolsError.prototype.toJSON = function () {
        return {
            status: this.status,
            message: this.message,
            data: this.data
        };
    };
    CommercetoolsError.prototype.toString = function () {
        return json_stringify_safe_1.default(this.toJSON());
    };
    return CommercetoolsError;
}(Error));
exports.CommercetoolsError = CommercetoolsError;
//# sourceMappingURL=CommercetoolsError.js.map